import {
  FIND_CATEGORIES_REQUEST,
  FIND_CATEGORIES_SUCCESS,
  FIND_CATEGORIES_FAILURE,
  CREATE_CATEGORY_REQUEST,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
} from "./ActionType";
import api, { API_BASE_URL } from "../../../config/api";

// Fetch Categories
export const findCategories = () => async (dispatch) => {
  try {
    dispatch({ type: FIND_CATEGORIES_REQUEST });
    const { data } = await api.get(`${API_BASE_URL}/api/categories`);

    dispatch({
      type: FIND_CATEGORIES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FIND_CATEGORIES_FAILURE,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};

// Create Category
export const createCategory = (categoryData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_CATEGORY_REQUEST });
    const { data } = await api.post(`${API_BASE_URL}/api/categories/`, categoryData?.data);
    dispatch({
      type: CREATE_CATEGORY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_CATEGORY_FAILURE,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};

// Update Category
export const updateCategory = (categoryId, categoryData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_CATEGORY_REQUEST });
    const { data } = await api.put(`${API_BASE_URL}/api/categories/${categoryId}`, categoryData);
    dispatch({
      type: UPDATE_CATEGORY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_CATEGORY_FAILURE,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};

// Delete Category
export const deleteCategory = (categoryId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CATEGORY_REQUEST });
    await api.delete(`${API_BASE_URL}/api/categories/${categoryId}`);
    dispatch({
      type: DELETE_CATEGORY_SUCCESS,
      payload: categoryId,
    });
  } catch (error) {
    dispatch({
      type: DELETE_CATEGORY_FAILURE,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};
